import { useTranslation } from 'react-i18next';
import { cx } from '@platform/core/lib/cx';
import type { ILayoutCardProps } from './ILayoutCardProps';

/**
 * Картка «Порядок груп» (прототип v4 gsGroups): номер, назва групи 600, «↑» і «↓» (крайні вимкнені, але на вигляд як інші — як у прототипі;
 * без права змінювати вимкнені всі) — порядок зберігається одразу.
 */
export function LayoutOrderCard({ layout, canEdit, onSave }: ILayoutCardProps) {
  const { t } = useTranslation();
  const move = (i: number, d: number) => {
    const order = [...layout.groupOrder];
    [order[i], order[i + d]] = [order[i + d]!, order[i]!];
    onSave({ ...layout, groupOrder: order });
  };
  return (
    <section className="cu-panel" aria-label={t('sysCust.layout.order')}>
      <div className="cu-titles"><div className="sp-eyebrow">{t('sysCust.layout.order')}</div><div className="sp-muted">{t('sysCust.layout.orderDesc')}</div></div>
      <ol className={cx('cu-order', canEdit && 'is-editable')}>
        {layout.groupOrder.map((g, i, all) => (
          <li key={g} className="cu-order__row">
            <span className="sp-mono sp-muted">{i + 1}</span><span className="sp-strong">{t(`sysCust.layout.groups.${g}`, { defaultValue: g })}</span>
            <span className="sp-actions">
              <button type="button" className="sp-btn cu-order__btn" disabled={!canEdit || i === 0} aria-label={t('sysCust.layout.up')} onClick={() => move(i, -1)}>↑</button>
              <button type="button" className="sp-btn cu-order__btn" disabled={!canEdit || i === all.length - 1} aria-label={t('sysCust.layout.down')} onClick={() => move(i, 1)}>↓</button>
            </span>
          </li>
        ))}
      </ol>
    </section>
  );
}
